import { EditIcon } from '@/lib/Icons/Icons/Icons';
import { twMerge } from 'tailwind-merge';
import { DEFAULT_TITLE_STYLES } from './EditableTitleView.styles';

type EditableTitleViewProps = {
  title: string;
  isEditable?: boolean;
  className?: string;
  onEditClick: () => void;
};


export function EditableTitleView({ title, isEditable = true, className, onEditClick }: EditableTitleViewProps) {
  return (
    <button
      type='button'
      className={twMerge(
        'flex items-center gap-2 motion-safe:transition-colors motion-safe:duration-200 motion-reduce:transition-none border-0 bg-transparent p-0 text-left',
        isEditable && 'cursor-pointer'
      )}
      onClick={onEditClick}
      disabled={!isEditable}
    >
      <div className='group flex items-center gap-2'>
        <h1
          className={twMerge(
            DEFAULT_TITLE_STYLES,
            className,
            'text-primary-900 motion-safe:transition-colors motion-safe:duration-200 motion-reduce:transition-none',
            isEditable && 'hover:text-brand-600'
          )}
        >
          {title}
        </h1>
        {isEditable && (
          <EditIcon className='size-5 text-quaternary-400 opacity-0 hover:!opacity-100 group-hover:opacity-100 motion-safe:transition-opacity motion-safe:duration-200 motion-reduce:transition-none' />
        )}
      </div>
    </button>
  );
}
